export default __webpack_public_path__ + "static/sedan-7b5dba6f6e07e87134fb4dd12a04a981.png";